import axiosClient from "@/shared/lib/axios/axios";
import { ApiResponse } from "@/shared/types/api";
import { API_ROUTES } from "../config";
import { MLExportRun, MLExportRunPlan, RunCreateInput } from "../../types/run";

export const planExportRun = async (input: RunCreateInput) => {
  // plan and create take the SAME body — do NOT strip destination / project_key.
  const res = await axiosClient.post<ApiResponse<MLExportRunPlan>>(
    API_ROUTES.RUNS_PLAN,
    input
  );
  return res?.data?.data ?? null;
};

export const createExportRun = async (input: RunCreateInput) => {
  const res = await axiosClient.post<ApiResponse<MLExportRun>>(API_ROUTES.RUNS, input);
  return res?.data?.data ?? null;
};

export const getRunDetail = async (runId: string) => {
  const res = await axiosClient.get<ApiResponse<MLExportRun>>(`${API_ROUTES.RUNS}${runId}/`);
  return res?.data?.data ?? null;
};

export const getRunsHistory = async (limit?: number): Promise<MLExportRun[]> => {
  const res = await axiosClient.get<ApiResponse<MLExportRun[]>>(
    API_ROUTES.RUNS_HISTORY,
    { params: limit ? { limit } : undefined }
  );
  return res?.data?.data ?? [];
};

export const cancelRun = async (runId: string) => {
  const res = await axiosClient.post<ApiResponse<MLExportRun>>(`${API_ROUTES.RUNS}${runId}/cancel/`);
  return res?.data?.data ?? null;
};
